import {
	FETCH_USER_DATA_REQUEST,
	FETCH_USER_DATA_SUCCESS,
	FETCH_USER_DATA_FAILURE,
} from '../../constants';

const initialState = {
	data: [],
	loading: false,
	error: null,
};

const allEmployeeDataReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_USER_DATA_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case FETCH_USER_DATA_SUCCESS:
			return {
				...state,
				data: action.payload,
				loading: false,
				error: null,
			};
		case FETCH_USER_DATA_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: []
			};
		default:
			return state;
	}
};

export default allEmployeeDataReducer;
